var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thermal-root"},[(_vm.loading)?_c('div',{staticClass:"thermal-loading"},[_vm._v("Preparing print...")]):(_vm.error)?_c('div',{staticClass:"thermal-error"},[_vm._v(_vm._s(_vm.error))]):_c('pre',{staticClass:"thermal-page"},[_vm._v(_vm._s(_vm.receiptText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }